import React from 'react'
import { Box, ImageLoader, Text } from '@usap/uicomponents'
import SetKitDisplay from '../../SetKitDisplay'

export default function ReturnDetailsItemInfo({ orderDetails, isDesktop }) {
  const { item } = orderDetails
  let vehicleInfo = ''
  if (item.vehicle) {
    const {
      year,
      make,
      model,
      submodel,
      engine,
    } = item.vehicle
    if (year && make && model) {
      vehicleInfo = `${year} ${make} ${model}`
      vehicleInfo += submodel ? `&nbsp; ${submodel}` : ''
      vehicleInfo += engine ? `&nbsp; ${engine}` : ''
    }
  }

  const returnReasonDisplay = orderData => {
    const {
      reasons,
      uploaded,
    } = orderData
    if (reasons === null) {
      return null
    }
    return (
      <>
        <Box>
          <Text size="small" color="dark-2" weight="bold">Return Details:</Text>
          <ul style={{ margin: 0, padding: '0 17px' }}>
            {
                reasons.map(data => (

                  <li
                    style={{
                      margin: 0,
                      fontSize: '14px',
                      color: '#333',
                    }}
                    key={data.id}
                  >
                    { data.answer }
                  </li>
                ))
              }
          </ul>
        </Box>
        <Box direction="row" gap="medium" margin={{ top: '16px' }}>
          {
            uploaded.images.map(data => (

              <Box width="64px" key={data.id}>
                <ImageLoader
                  fit="contain"
                  src={data.url}
                  width="100%"
                  height="100%"
                  cloudinaryParams="w_100,h_80"
                />
              </Box>
            ))
          }
        </Box>
      </>
    )
  }

  const itemInfo = orderData => {
    const {
      // eslint-disable-next-line camelcase
      title,
      image,
      brand,
      part,
      quantity,
      shipping,
      sku,
      price,
      warranty,
      core,
    } = orderData

    const { parentItem } = item

    const parentSku = parentItem ? {
      sku_title: parentItem.title,
      ImageURL: parentItem.image.url,
      sku: parentItem.sku,
      list_price: parentItem.price.list,
    } : null
    const defaultImage = 'https://cld.partsimg.com/image/upload/d_noimage.jpg'
    const imageSizeContainer = isDesktop ? '110px' : '160px'
    const corePrice = core && core.price ? core.price : 0
    const warrantyPrice = warranty && warranty.price ? warranty.price : 0
    const subTotal = price.list + warrantyPrice + corePrice
    let imageUrl = `${defaultImage}/images/${sku.toLowerCase()}_1.jpg`
    if (image) {
      imageUrl = image.url
    }
    return (
      <Box>
        <Box direction="row" align="start">
          <Box width={imageSizeContainer}>
            <ImageLoader
              fit="contain"
              alt={title || null}
              src={imageUrl}
              width="100%"
              height="100%"
              cloudinaryParams="w_100,h_80"
            />
          </Box>
          <Box margin={{ left: '16px' }}>
            {
              vehicleInfo && (
                <Text
                  color="dark-1"
                  dangerouslySetInnerHTML={
                    {
                      __html: `
                        FOR&nbsp;
                        ${vehicleInfo}
                      `,
                    }
                  }
                  size="small"
                  style={{ lineHeight: '24px' }}
                />
              )
            }
            <Text color="dark-2" size="small" style={{ lineHeight: '24px' }} weight="bold">
              { brand ? brand.name : null }
              &reg;
            </Text>
            <Text
              color="dark-2"
              size="small"
              style={{ lineHeight: '24px' }}
              dangerouslySetInnerHTML={
                {
                  __html: title || null
                }
              }
            />
            <Text color="dark-1" size="small" style={{ lineHeight: '24px' }}>
              Part no.:&nbsp;
              {sku}
            </Text>
            <Text color="dark-2" size="small" style={{ lineHeight: '24px' }}>
              Qty:&nbsp;
              { quantity.return }
            </Text>
            { price && (
            <>
              <Text color="dark-2" size="small" style={{ lineHeight: '24px' }}>
                Unit Price:&nbsp;
                <Text color="dark-2" weight="bold" size="small" style={{ lineHeight: '24px' }}>
                  $
                  { price && price.list ? price.list.toFixed(2) : null }
                </Text>
              </Text>
              {
                corePrice > 0 && (
                  <Text color="dark-2" size="small" style={{ lineHeight: '24px' }}>
                    { core.label }
                    :&nbsp;
                    <Text color="dark-2" weight="bold" size="small" style={{ lineHeight: '24px' }}>
                      $
                      { core && core.price ? core.price.toFixed(2) : null }
                    </Text>
                  </Text>
                )
              }
              {
                warrantyPrice > 0 && (
                  <Text color="dark-2" size="small" style={{ lineHeight: '24px' }}>
                    { warranty.label }
                    :&nbsp;
                    <Text color="dark-2" weight="bold" size="small" style={{ lineHeight: '24px' }}>
                      $
                      { warranty && warranty.price ? warranty.price.toFixed(2) : null }
                    </Text>
                  </Text>
                )
              }
              <Text color="dark-2" size="small" weight="bold" style={{ lineHeight: '24px' }}>
                Item Total:&nbsp;
                <Text color="dark-2" weight="bold" size="small" style={{ lineHeight: '24px' }}>
                  $
                  { (subTotal * quantity.return).toFixed(2) }
                </Text>
              </Text>
            </>
            )}
            {
              shipping && shipping.method && (
                <Text color="dark-2" size="small" style={{ lineHeight: '24px' }}>
                  Shipping Method:&nbsp;
                  <Text color="dark-2" size="small" style={{ lineHeight: '24px' }}>
                    { shipping.method }
                  </Text>
                </Text>
              )
            }
            {
              isDesktop && (
                <Box margin={{ top: '16px' }}>
                  <SetKitDisplay
                    parentSku={parentSku}
                    style={{ margin: '8pt 4px', borderRadius: '4pt' }}
                  />
                </Box>
              )
            }
            {
              isDesktop && (
                <Box margin={{ top: '16px' }}>
                  { returnReasonDisplay(orderData) }
                </Box>
              )
            }
          </Box>
        </Box>
        {
          !isDesktop && (
            <Box margin={{ top: '16px' }}>
              <SetKitDisplay
                parentSku={parentSku}
                style={{ margin: '8pt 4px', borderRadius: '4pt' }}
              />
            </Box>
          )
        }
        {
          !isDesktop && (
            <Box margin={{ top: '16px' }}>
              { returnReasonDisplay(orderData) }
            </Box>
          )
        }
      </Box>
    )
  }

  return (
    <Box
      pad="medium"
      margin={{ top: '16px' }}
      round="small"
      border={{
        color: '#CCCACA',
        size: 'small',
        side: 'all',
      }}
    >
      { itemInfo(item) }
    </Box>
  )
}
